import React, { Component } from "react";
import axios from "axios";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import ViewIcon from "@material-ui/icons/Visibility";
import FreshDeskTicket from "../FreshDeskTicket";
import { Tooltip } from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";

const useStyles = theme => ({
  menu: {
    fontSize: "0.75rem"
  }
});

class BasicData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      work_order: {
        hansa_code: "",
        reason: "",
        work_order_type_id: "",
        internal_code: "",
        internal_code_type: "",
        work_order_origin_id: "",
        work_order_expense_type_id: ""
      },
      work_order_expense_types: []
    };
  }

  componentDidMount() {
    var work_order = this.props.work_order;
    if (work_order.id > 0) {
      var type = this.props.work_order_types.filter(
        type => type.id === parseInt(work_order.work_order_type_id)
      );
      var work_order_expense_types = type[0].expenses;
      this.setState({ work_order_expense_types: work_order_expense_types });
    }
    this.setState({ work_order: work_order });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ work_order: nextProps.work_order });
    //		this.setState({contact_location: nextProps.contact_location})
  }
  onTicketConfirmed = freshdesk_code => {
    var work_order = this.state.work_order;
    work_order["freshdesk_code"] = freshdesk_code;
    this.setState({ work_order: work_order });
    this.props.forceSave();
  };

  handleChange = e => {
    var work_order = this.state.work_order;
    if (e.target.id) {
      work_order[e.target.id] = e.target.value;
    } else {
      work_order[e.target.name] = e.target.value;
    }

    if (e.target.name === "work_order_type_id") {
      work_order.work_order_expense_type_id = "";
      var type = this.props.work_order_types.filter(
        type => type.id === parseInt(e.target.value)
      );
      //var work_order_expense_types = type[0].expenses
      //work_order_expense_types = [...new Map(work_order_expense_types.map(item => [item.expense.id, item])).values()]

      if (type[0].default_work_order_origin_id) {
        work_order.work_order_origin_id = type[0].default_work_order_origin_id;
      } else {
        work_order.work_order_origin_id = "";
      }
      var work_order_expense_types = type[0].expenses;

      if (
        this.state.work_order.is_fleet_owner === 0 ||
        this.state.work_order.is_fleet_owner === 1
      ) {
        var work_order_expense_type = work_order_expense_types.filter(
          expense_type =>
            expense_type.fleet_owner ===
              parseInt(this.state.work_order.is_fleet_owner) &&
            expense_type.work_order_type_id === e.target.value &&
            expense_type.default === 1
        );
        if (work_order_expense_type[0]) {
          work_order.work_order_expense_type_id =
            work_order_expense_type[0].work_order_expense_type_id;
        }
      }
      if (!work_order.reason && type[0].default_reason) {
        work_order.reason = type[0].default_reason;
      }
      work_order.initial_detail = type[0].initial_detail;
      //this.setState({work_order_expense_types: work_order_expense_types})
    }
    this.setState({ work_order: work_order });
    if (e.target.name === "work_order_type_id") {
      this.props.onTypeChanged();
    }
  };

  render() {
    const basic_data = this.state.work_order;
    const classes = this.props.classes;
    var type = this.props.work_order_types.filter(
      type => type.id === parseInt(this.state.work_order.work_order_type_id)
    );
    var work_order_expense_types = [];
    if (type.length > 0) {
      work_order_expense_types = type[0].expenses;
      if (
        parseInt(this.state.work_order.is_fleet_owner) === 0 ||
        parseInt(this.state.work_order.is_fleet_owner) === 1
      ) {
        work_order_expense_types = work_order_expense_types.filter(
          expense_type =>
            expense_type.fleet_owner ===
            parseInt(this.state.work_order.is_fleet_owner)
        );
      }
    } else {
      work_order_expense_types = this.state.work_order_expense_types;
    }
    const freshdesk_url = process.env.REACT_FRESHDESK_URL
      ? process.env.REACT_FRESHDESK_URL
      : "https://autocorpar.freshdesk.com/support/tickets/";
    let showFreshDeskTicket = false;
    if (this.props.work_order.id && type[0] && type[0].freshdesk_type) {
      showFreshDeskTicket = true;
    }
    return (
      <React.Fragment>
        {/*
				<TextField
				  id="hansa_code"
				  name="hansa_code"
				  disabled={true}
				  onChange={this.handleChange}
				  type="text"
				  value={basic_data.hansa_code}
				  margin="normal"
				  className="mr-2 mt-1"
				  InputLabelProps={{
					shrink: true
				  }}
				  inputProps={{style:{width: 45, fontSize: '0.75rem'}}}
				  InputProps={{
					startAdornment: <InputAdornment position="start" ><Typography variant="caption"># Hansa</Typography></InputAdornment>,
				  }}
				/>
				*/}
        <TextField
          id="work_order_type_id"
          name="work_order_type_id"
          disabled={
            basic_data.id > 0 && basic_data.state !== "borrador" ? true : false
          }
          select
          margin="normal"
          className="mr-2 mt-1"
          InputLabelProps={{
            shrink: true
          }}
          onChange={this.handleChange}
          value={basic_data.work_order_type_id}
          inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Typography variant="caption" style={{ width: 60 }}>
                  Tipo de OT
                </Typography>
              </InputAdornment>
            ),
            style: { fontSize: "0.75rem" }
          }}
        >
          {this.props.work_order_types.map(option => (
            <MenuItem
              key={option.id}
              value={option.id}
              className={classes.menu}
            >
              {option.name}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          id="reason"
          placeholder="Ingrese una descripción"
          name="reason"
          margin="normal"
          className="mr-2 mt-1	"
          value={basic_data.reason}
          InputLabelProps={{
            shrink: true
          }}
          onChange={this.handleChange}
          inputProps={{ style: { minWidth: 150, fontSize: "0.75rem" } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Typography variant="caption">Descripción</Typography>
              </InputAdornment>
            )
          }}
        />
        <TextField
          id="work_order_origin_id"
          name="work_order_origin_id"
          select
          margin="normal"
          className="mr-2 mt-1"
          InputLabelProps={{
            shrink: true
          }}
          onChange={this.handleChange}
          value={basic_data.work_order_origin_id}
          inputProps={{ style: { minWidth: 30, fontSize: "0.75rem" } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Typography variant="caption" style={{ width: 35 }}>
                  Origen{" "}
                </Typography>
              </InputAdornment>
            ),
            style: { fontSize: "0.75rem" }
          }}
        >
          {this.props.work_order_origins.map(option => (
            <MenuItem
              key={option.id}
              value={option.id}
              className={classes.menu}
            >
              {option.name}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          id="internal_code"
          name="internal_code"
          type="text"
          value={basic_data.internal_code}
          onChange={this.handleChange}
          margin="normal"
          className="mr-2 mt-1"
          InputLabelProps={{
            shrink: true
          }}
          inputProps={{
            style: {
              width: 50,
              fontSize: "0.75rem",
              display: basic_data.internal_code_type !== "" ? "block" : "none"
            }
          }}
          InputProps={{
            //			            startAdornment: <InputAdornment position="start" ><Typography variant="caption">Cod. interno</Typography></InputAdornment>,
            startAdornment: (
              <TextField
                id="internal_code_type"
                name="internal_code_type"
                select
                InputLabelProps={{
                  shrink: true
                }}
                onChange={this.handleChange}
                value={basic_data.internal_code_type}
                inputProps={{ style: { fontSize: "0.75rem" } }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">Cod. Interno</Typography>
                    </InputAdornment>
                  ),
                  style: { width: "auto", fontSize: "0.75rem" }
                }}
              >
                <MenuItem key="" value="" className={classes.menu}>
                  Sin especificar
                </MenuItem>
                {this.props.work_order_internal_code_types.map(option => (
                  <MenuItem
                    key={option.id}
                    value={option.id}
                    className={classes.menu}
                  >
                    {option.name}
                  </MenuItem>
                ))}
              </TextField>
            )
          }}
        />
        <Tooltip
          className="mt-2 mr-2"
          title={
            <React.Fragment>
              <Typography style={{ fontSize: "0.75rem" }}>
                {basic_data.client_purchase_order_status ? (
                  <div>
                    Estado OC:{" "}
                    <span style={{ fontSize: "0.8rem", fontWeight: 600 }}>
                      {basic_data.client_purchase_order_status.valid == true
                        ? "Valida"
                        : "Invalida"}{" "}
                      - {basic_data.client_purchase_order_status.status}
                    </span>
                  </div>
                ) : (
                  ""
                )}
              </Typography>
            </React.Fragment>
          }
        >
          <InfoIcon style={{ display: "block", width: 15 }} />
        </Tooltip>
        {basic_data.client_purchase_order && (
          <>
            <TextField
              id="purchase_order"
              name="purchase_order"
              disabled
              margin="normal"
              className="mr-2 mt-1"
              InputLabelProps={{
                shrink: true
              }}
              //onChange={this.handleChange}
              value={basic_data.client_purchase_order}
              inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption" style={{ width: 60 }}>
                      OC Cliente
                    </Typography>
                  </InputAdornment>
                ),
                style: { fontSize: "0.75rem" }
              }}
            />
          </>
        )}
        <TextField
          id="work_order_expense_type_id"
          name="work_order_expense_type_id"
          select
          margin="normal"
          className="mr-2 mt-1"
          InputLabelProps={{
            shrink: true
          }}
          onChange={this.handleChange}
          value={basic_data.work_order_expense_type_id}
          inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Typography variant="caption" style={{ width: 45 }}>
                  Gasto
                </Typography>
              </InputAdornment>
            ),
            style: { fontSize: "0.75rem" }
          }}
        >
          {work_order_expense_types.map(option => (
            <MenuItem
              key={option.expense.id}
              value={option.expense.id}
              className={classes.menu}
            >
              {option.expense.name}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          id="freshdesk_code"
          name="freshdesk_code"
          onChange={this.handleChange}
          type="text"
          disabled={
            parseInt(basic_data.freshdesk_code_validated) === 1 ||
            basic_data.freshdesk_code_validated === true
              ? true
              : false
          }
          value={basic_data.freshdesk_code}
          margin="normal"
          className="mr-2 mt-1"
          InputLabelProps={{
            shrink: true
          }}
          inputProps={{ style: { width: 50, fontSize: "0.75rem" } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Typography variant="caption">
                  # Fresh{" "}
                  {basic_data.freshdesk_code ? (
                    <ViewIcon
                      fontSize="small"
                      className="ml-1"
                      onClick={() =>
                        window.open(freshdesk_url + basic_data.freshdesk_code)
                      }
                    />
                  ) : (
                    showFreshDeskTicket && (
                      <FreshDeskTicket
                        data={{
                          subject: basic_data.reason,
                          plate: this.props.vehicle.plate,
                          contact_email: this.props.vehicle.contact_email,
                          contact_name: this.props.vehicle.contact_name,
                          type: type[0] ? type[0].freshdesk_type : "",
                          external_id: this.props.work_order.id
                        }}
                        onTicketConfirmed={this.onTicketConfirmed}
                      />
                    )
                  )}
                </Typography>
              </InputAdornment>
            )
          }}
        />
      </React.Fragment>
    );
  }
}

export default withStyles(useStyles)(BasicData);
